import { useState, useEffect } from 'react';
import axios from "axios";

const authorizedHeader = () => {
  const authToken = localStorage.getItem("authToken");
  if (authToken) {
    return {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    };
  } else {
    return { "Content-Type": "application/json" };
  }
};

export const useFetchLive = (url, params) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getAPIData = async () => {
      setLoading(true);
      setError(null);

      try {
          const response = await axios({
            method: "GET",
            url,
            params,
            headers: authorizedHeader(),
          });
          setData(response.data);
      } catch (error) {
        // throw e;
        setError(error.message);
      } finally{
        setLoading(false);
      }
    }
    getAPIData();

    const interval = setInterval(getAPIData, 1 * 60 * 1000);
    return () => clearInterval(interval);

  }, [url, params]);
  return { data, loading, error };
};
